import {
  FormControl,
  InputLabel,
  Select as MuiSelect,
  MenuItem,
  OutlinedInput,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { ChangeEvent, memo, useState } from "react";
import { Control, Controller, UseFormMethods } from "react-hook-form";
import { useSelector } from "react-redux";

import { withError } from "../HOC";
import { CommonFormElProps } from "../types";

import styles from "./SelectModel.module.scss";

export type SelectModelItem = {
  value: string;
  label: string;
};

export type SelectModelProps = {
  readonly control: Control;
  readonly items: Array<SelectModelItem>;
  readonly trigger: UseFormMethods["trigger"];
  readonly selectAvailableModels: any;
} & CommonFormElProps;

export const SelectModel = memo<SelectModelProps>(
  ({
    control,
    defaultValue,
    disabled: isDisabled,
    hasError,
    id,
    items,
    label,
    required = false,
    trigger,
    selectAvailableModels,
  }) => {
    const [otherModelAvailability, setOtherModelAvailability] = useState(false);
    const models = useSelector(selectAvailableModels) as {
      label: string;
      value: string;
    }[];

    return (
      <FormControl>
        <InputLabel
          shrink
          disabled={isDisabled}
          required={!isDisabled && required}
        >
          {label}
        </InputLabel>
        <div className={styles.container}>
          {models.length > 0 && !otherModelAvailability ? (
            <Controller
              className={styles.controller}
              name={id}
              control={control}
              defaultValue={defaultValue}
              render={({ onChange, value }) => (
                <MuiSelect
                  className={styles.controller}
                  disabled={isDisabled}
                  error={hasError}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    onChange(selectedValue);
                  }}
                  id={id}
                  variant="outlined"
                  value={value}
                >
                  {models.map(({ label, value }) => (
                    <MenuItem key={value} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </MuiSelect>
              )}
            />
          ) : (
            <Controller
              name={id}
              control={control}
              className={styles.controller}
              defaultValue={defaultValue}
              as={
                <OutlinedInput
                  autoComplete="off"
                  defaultValue={defaultValue}
                  disabled={isDisabled}
                  error={hasError}
                  id={id}
                  inputProps={{
                    name: id,
                  }}
                />
              }
            ></Controller>
          )}
          <FormControlLabel
            control={
              <Checkbox
                color="secondary"
                checked={otherModelAvailability}
                onChange={() => setOtherModelAvailability((prev) => !prev)}
              />
            }
            label="Inne"
          />
        </div>
      </FormControl>
    );
  }
);

export const SelectModelWithError = withError(SelectModel);
